export default __webpack_public_path__ + "static/ga-9e11d1fe9eba27206be1e1dc9bd7082a.svg";